import MainElectronController from './main.controller';

export default {
    controller: MainElectronController,
    template: require('./main.tpl.html')
};
